import { getSharingLinkInfo, preloadLinkData, SharingLinkInfo } from 'owa-link-data';

export async function getSharingLinkInfoAndVerifyHref(
    anchorElement: HTMLAnchorElement
): Promise<SharingLinkInfo> {
    await preloadLinkData.import();

    let sharingLink: SharingLinkInfo = getSharingLinkInfo(anchorElement.id);
    if (sharingLink && anchorElement.href !== sharingLink.url) {
        sharingLink = null;
    }

    return sharingLink;
}
